// Angular Modules
import { Injectable } from '@angular/core';
@Injectable()
export class Constants {
  public readonly API_ENDPOINT: string = ' http://localhost:1337/backend/';
}

export const DEVEXTREME_LICENSE_KEY =
  'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjQxNjhiYjMwLWNiMGYtNDU2My1iZGMzLWJiODAxNzNkOGVmYyIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUxCn0=.r95PgA7tLmPkVBM1jEKxxQKM3kUsQ3zf77nZqRBXKAuyTKf9pqLKp42ElgBYTVKYzZhvU4cuInhoXBd7ynIvdGwGswWE15YnMCJW6u0vIHCfA7d75TK74NfMw7d1dPELPb7mtg==';
